import { render } from "./BillsCreateNew.vue?vue&type=template&id=1af16c21"
import script from "./BillsCreateNew.vue?vue&type=script&lang=js"
export * from "./BillsCreateNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__